import { TRIGGER_FETCH_PREPAID_TXN_LIST_API_SUCCESS } from 'redux/actionTypes';

const initialState = [];

// export const locale[];

const PrePaidTxnListReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_FETCH_PREPAID_TXN_LIST_API_SUCCESS:
			return {
				...state,
				...action.data,
			};
		default:
			return state;
	}
};

export default PrePaidTxnListReducer;
